import { combineReducers } from '@reduxjs/toolkit';
import Auth from "./Auth";

const rootReducer = (history) => combineReducers({
    auth: Auth,
});

export default rootReducer;